// extracted by mini-css-extract-plugin
export var card = "_6l-0";
export var failedIcon = "_6l-4";
export var failedIconBadge = "_6l-3";
export var icon = "_6l-1";
export var successIcon = "_6l-2";